import React from "react";
import Modal from "../../../components/modal";

const TaskUserListModal = ({ show, onClose, heading, initialData = {} }) => {
    const taskUsers = initialData?.TaskUsers || [];
    console.log(taskUsers);
    return (
        <Modal show={show} onClose={onClose} heading={heading}>
            <div className="table-responsive">
                {taskUsers.length > 0 ? (
                    <table className="table table-bordered">
                        <thead className="thead-dark">
                            <tr>
                                <th>#</th>
                                <th>Name</th>
                                <th>Email</th>
                                <th>Mobile No</th>
                            </tr>
                        </thead>
                        <tbody>
                            {taskUsers.map((user, index) => (
                                <tr key={user.id}>
                                    <td>{index + 1}</td>
                                    <td>{user.BranchUser?.name || "N/A"}</td>
                                    <td>{user.BranchUser?.email || "N/A"}</td>
                                    <td>{user.BranchUser?.mobile_no || "N/A"}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                ) : (
                    <p className="text-center">No users assigned to this task.</p>
                )}
            </div>
        </Modal>
    );
};

export default TaskUserListModal;
